import { useEffect } from 'react';

const SYNC_REFRESH_TABS_DATE_KEY = 'logout:date';
const SYNC_REFRESH_TABS_URL_KEY = 'logout:url';

const useSyncRefreshTabs = () => {
    const handleStorageEvent = (event: StorageEvent): void => {
        if (event.key === SYNC_REFRESH_TABS_DATE_KEY) {
            const href = window.localStorage.getItem(SYNC_REFRESH_TABS_URL_KEY);
            setTimeout(() => syncRefreshTabs(href || ''), 100); // let the main tab refresh first
        }
    };

    const syncRefreshTabs = (href = '') => {
        if (href) {
            window.location.href = href;
        } else {
            window.location.reload();
        }
    };

    useEffect(() => {
        window.addEventListener('storage', handleStorageEvent);
        return () => {
            window.removeEventListener('storage', handleStorageEvent);
            window.localStorage.removeItem(SYNC_REFRESH_TABS_DATE_KEY);
            window.localStorage.removeItem(SYNC_REFRESH_TABS_URL_KEY);
        };
    }, []);

    return (href = '', options: { onlyReloadOtherTabs?: boolean } = { onlyReloadOtherTabs: false }) => {
        window.localStorage.setItem(SYNC_REFRESH_TABS_DATE_KEY, Date.now().toString());
        window.localStorage.setItem(SYNC_REFRESH_TABS_URL_KEY, options?.onlyReloadOtherTabs ? '' : href);

        syncRefreshTabs(href);
    };
};

export default useSyncRefreshTabs;
